import { Component, OnInit, Input, ElementRef, ViewChild } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DomSanitizer } from '@angular/platform-browser';
import { SafeHtmlUtils } from '../../utils/safe-html.util';
import { Observable, Subscription } from 'rxjs';

@Component({
  selector: 'frg-inline-svg',
  templateUrl: './inline-svg.fragment.html',
  styleUrls: ['./inline-svg.fragment.scss']
})
export class InlineSvgFragment implements OnInit {

  @ViewChild('element') element: ElementRef;

  @Input() src: string;
  @Input() fill?: string;
  @Input() stroke?: string;
  @Input() hoverFill?: string;
  @Input() hoverStroke?: string;
  @Input() hoverMonitor?: Observable<{ event: MouseEvent, hover: boolean }>;
  public svg;
  public subHover: Subscription;

  constructor(
    public http: HttpClient,
    public san: DomSanitizer,
    public document: Document
  ) { }

  async ngOnInit(): Promise<void> {
    if (this.hoverMonitor) {
      this.subHover = this.hoverMonitor.subscribe((res) => {
        if (this.element) {
          if ((res.event.target as any).children[0].children[0] === this.element.nativeElement) {
            res.hover ? this.onHover() : this.initSvg();
          }
        }
      });
    }
    await this.initSvg();
  }

  public async initSvg(): Promise<void> {
    if (this.src) {
      const svgHtml = await this.http.get(this.src, { responseType: 'text' }).toPromise();
      if (this.fill || this.stroke) {
        const truc = this.document.createElement('svg');
        truc.innerHTML = svgHtml;
        if (this.fill) {
          truc.querySelectorAll('path').forEach(element => {
            element.setAttribute('fill', this.fill);
          });
        }
        if (this.stroke) {
          truc.querySelectorAll('path').forEach(element => {
            element.setAttribute('stroke', this.stroke);
          });
        }
        this.svg = SafeHtmlUtils.sanitizeSvgAndBypass(truc.innerHTML, this.san);
      } else {
        this.svg = SafeHtmlUtils.sanitizeSvgAndBypass(svgHtml, this.san);
      }
    }
  }

  public async onHover(): Promise<void> {
    if (this.src) {
      const svgHtml = await this.http.get(this.src, { responseType: 'text' }).toPromise();
      if (this.fill || this.stroke) {
        const truc = this.document.createElement('svg');
        truc.innerHTML = svgHtml;
        if (this.fill) {
          truc.querySelectorAll('path').forEach(element => {
            element.setAttribute('fill', this.hoverFill);
          });
        }
        if (this.stroke) {
          truc.querySelectorAll('path').forEach(element => {
            element.setAttribute('stroke', this.hoverStroke);
          });
        }
        this.svg = SafeHtmlUtils.sanitizeSvgAndBypass(truc.innerHTML, this.san);
      } else {
        this.svg = SafeHtmlUtils.sanitizeSvgAndBypass(svgHtml, this.san);
      }
    }
  }

}
